import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'

import Button from 'components/Button'
import content from 'prismic-translates/common.json'
import { useAppSelector } from 'src/store/hooks'
import { isLoggedInSelector } from 'store/modules/user/selectors'
import type { SupportedCurrencies } from 'types/currencies'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  gameProduct: GameProduct
  activeCurrency?: SupportedCurrencies
  className?: string
  startExternalGameFlow: (gameProduct: GameProduct, activeCurrency: SupportedCurrencies) => void
}
export default function PlayGameButton(props: Props) {
  const { activeCurrency, gameProduct } = props
  const isLogged = useAppSelector(isLoggedInSelector)
  const buttonColor = isLogged ? props.activeCurrency : null

  const onPlayPress = () => {
    props.startExternalGameFlow(gameProduct, activeCurrency)
  }

  return (
    <Button
      data-test='descr-play-btn'
      className={cx(classes.button, props?.className)}
      onClick={onPlayPress}
      color={buttonColor}
    >
      {isLogged ? `Play ${gameProduct.title} Now!` : t('login')}
    </Button>
  )
}
